import loadable from '@loadable/component';

export const ForgotPasswordPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ForgotPasswordPageContainer" */
      './ForgotPasswordPageContainer.dynamic'
    ),
);
